const state = {
  menuLocation: 'sidebar'
}

const mutations = {
  SET_MENU_LOCATION (state, menuLocation) {
    state.menuLocation = menuLocation
  }
}

const actions = {}

const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}
